import React from 'react'
import { ICellRendererParams } from 'ag-grid-enterprise'
import { Button } from 'antd'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { EnhancedStatementRow } from '../../../../utils/dataEnhancement'
import { notLocked } from '../../../../../../pages/settings/company/budgeting/budgetingScenarios/utils'
import { filtersSelector } from '../../../../../../redux/context/filters/selectors'
import { useCtxCompanyGroupBudgetSource } from '../../../../../companyGroup/queries/companyGroupSetting/useCtxCompanyGroupSettings'
import { GroupSettingDataSource } from '../../../../../companyGroup/types/CompanyGroupSettings'
import { useModalActions } from '../../ModalContext'

export const AmendmentMenuCellRenderer: React.FC<ICellRendererParams<EnhancedStatementRow>> = ({ data }) => {
  const { t } = useTranslation()
  const { data: groupBudgetSourceSetting } = useCtxCompanyGroupBudgetSource()
  const { budgetingScenario } = useSelector(filtersSelector)
  const { openAmendmentModal } = useModalActions()
  const isDisabled = !notLocked(budgetingScenario) || groupBudgetSourceSetting === GroupSettingDataSource.subsidiaries

  const handleAmendmentClick = () => {
    if (data) {
      openAmendmentModal({ data })
    }
  }

  return (
    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
      <Button type="default" size="small" disabled={isDisabled} onClick={handleAmendmentClick}>
        {t('financialStatementsPage:amendment')}
      </Button>
    </div>
  )
}
